import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import HeaderLogo from "../../../assets/Broward-Partnerships-for-kids-logo.png";

const toBase64 = (url) =>
  fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );

const generateCommitteeReport = async (data, isLandscape, title) => {
  const doc = new jsPDF({
    orientation: isLandscape ? "landscape" : "portrait",
  });

  const logoBase64 = await toBase64(HeaderLogo);

  // Add logo at top center
  const imgProps = doc.getImageProperties(logoBase64);
  const pdfWidth = doc.internal.pageSize.getWidth();
  const imgWidth = 50; // Adjust size as needed
  const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
  const imgX = (pdfWidth - imgWidth) / 2;
  const imgY = 5;
  const margin = 14;
  doc.addImage(logoBase64, "PNG", margin, imgY, imgWidth, imgHeight);

  /* Title */
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0, 1);
  const textWidth = doc.getTextWidth(title);
  const titleX = (pdfWidth - textWidth) / 2;
  const titleY = imgY + imgHeight / 2 + 5;
  doc.text(title, titleX, titleY);

  /* Current Date */
  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0, 0.3);
  const dateTextWidth = doc.getTextWidth(currentDate);
  const dateX = pdfWidth - margin - dateTextWidth;
  const dateY = titleY; // same vertical alignment as title
  doc.text(currentDate, dateX, dateY);

  const head = [
    [
      "Month & Year",
      "Committee Name",
      "Old Membership Count",
      "#Increase",
      "Current Membership Count",
      "%Increase",
    ],
  ];

  const body = data.map((item) => [
    item?.monthYear,
    item?.committeeName,
    item?.oldTotal,
    item?.increaseCount,
    item?.newTotal,
    item?.increasePercentage + "%",
  ]);

  autoTable(doc, {
    head,
    body,
    startY: 25,
    styles: {
      fontSize: 9,
      cellPadding: 3,
      // lineColor: [50, 50, 50],
      lineWidth: 0.1,
    },
    theme: "grid",
    headStyles: { fillColor: [22, 160, 133] },
    bodyStyles: {
      textColor: [0, 0, 0],
    },
    didDrawPage: (data) => {
      const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();
      const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

      const footer = `Page-${pageCurrent}`;
      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0, 0.3);
      doc.text(footer, pageWidth - 14, pageHeight - 10, { align: "right" });
    },
  });
  const now = new Date();

  const formattedDate =
    now.getFullYear() +
    "" +
    String(now.getMonth() + 1).padStart(2, "0") +
    "" +
    String(now.getDate()).padStart(2, "0");

  const formattedTime =
    String(now.getHours()).padStart(2, "0") +
    "" +
    String(now.getMinutes()).padStart(2, "0") +
    "" +
    String(now.getSeconds()).padStart(2, "0");

  const safeTitle = title.replace(/[^a-z0-9]/gi, "_");
  const fileName = `${safeTitle}_${formattedDate}_${formattedTime}.pdf`;

  doc.save(fileName);
};

export default generateCommitteeReport;
